import "bootstrap-icons/font/bootstrap-icons.css";
import jualan from "assets/pdf/auctions/Perisytiharan Jualan.pdf";
import auction from "assets/pdf/auctions/REPOSSESSED VEHICLE AUCTION ON 23.10.2024.pdf";
const auctionData = [
  {
    header: "Pengisytiharan Jualan",
    subheader: "Auction Info",
    date: "Tuesday 19th November 2024 at 9:00pm",
    linkText: "Click here for more details",
    linkHref: jualan,
  },
  {
    header: "Pengisytiharan Jualan",
    subheader: "Auction Info",
    date: "Thursday 2nd January 2025 at 11:00am",
    linkText: "Click here for more details",
    linkHref: "https://www.alrajhibank.com.my/assets/pdf/auctions/POS_2jan.pdf",
  },
  // {
  //   header: "Repossession Vehicle Auction",
  //   subheader: "Auction Info",
  //   date: "Wednesday 2 October 2024 at 12:00 pm",
  //   linkText: "Click here for more details",
  //   linkHref: "#",
  // },
  // {
  //   header: "Repossession Vehicle Auction",
  //   subheader: "Auction Info",
  //   date: "Monday 7 October 2024 at 11:00 am",
  //   linkText: "Click here for more details",
  //   linkHref: "#",
  // },
];

function Auctions() {
  return (
    <div className="container">
      <div className="my-5">
        <h1 style={{ fontWeight: "700", color: "#000045" }}>
          Repossession & Proclamation of Sale
        </h1>
      </div>
      <div className="col">
        <div className="row">
          {auctionData.map((auction, index) => (
            <div key={index} className="col-12 custom-column-2">
              <div className="column-header-2">{auction.header}</div>
              <div className="column-subheader-2">
                <u>
                  <b>{auction.subheader}</b>
                </u>
                <br />
                <br />
                {auction.date}
                <br />
                <a
                  href={auction.linkHref}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {auction.linkText}{" "}
                </a>{" "}
              </div>
            </div>
          ))}
        </div>
        <div
          className="pt-4"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* <PrimaryButton text="Proclamation of Sale - 7 October 2024" /> */}
        </div>
      </div>
    </div>
  );
}

export default Auctions;
